/**
 * Auth panel content — the brand panel beside the auth forms.
 *
 * Public read (pre-login, no auth):  GET /auth-panel/public/
 * Superadmin manage:                 GET/PUT /superadmin/auth-panel/
 *
 * Payload shape (both endpoints):
 *   {
 *     is_enabled: bool,
 *     content: {
 *       en: { tagline, tagline_accent, bullets: [] },
 *       ar: { tagline, tagline_accent, bullets: [] },
 *     },
 *     updated_at, updated_by,
 *   }
 */

import { apiService } from './api'

// Module-level cache: auth pages navigate between each other (login →
// forgot → otp …) and the panel content doesn't change mid-session, so
// one fetch per page load is enough.
let publicPanelPromise = null

export function fetchPublicAuthPanel() {
  if (!publicPanelPromise) {
    publicPanelPromise = apiService.get('/auth-panel/public/').then((res) => {
      if (res.success) return res.data?.data || null
      throw new Error(res.error?.message || 'Failed to load auth panel content')
    }).catch((err) => {
      // Allow a retry on the next mount instead of caching the failure.
      publicPanelPromise = null
      throw err
    })
  }
  return publicPanelPromise
}

export const authPanelAdminAPI = {
  get: () => apiService.get('/superadmin/auth-panel/'),
  update: (payload) => apiService.put('/superadmin/auth-panel/', payload),
}
